import * as Types from '../../../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InvoicingPriceListV2MetaQueryVariables = Types.Exact<{
  input: Types.PriceListMetaInput;
}>;


export type InvoicingPriceListV2MetaQuery = { readonly __typename?: 'Query', readonly priceListV2: { readonly __typename?: 'PriceListV2Queries', readonly priceListMeta?: { readonly __typename?: 'PriceListMeta', readonly id: string } | null } };

export type InvoicingPriceListV2QueryVariables = Types.Exact<{
  input: Types.PriceListItemsInput;
  options?: Types.InputMaybe<Types.PriceListItemsOptions>;
}>;


export type InvoicingPriceListV2Query = { readonly __typename?: 'Query', readonly priceListV2: { readonly __typename?: 'PriceListV2Queries', readonly priceListItems: { readonly __typename?: 'PriceableItemConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'PriceableItem', readonly id: string, readonly name: string, readonly externalReference: { readonly __typename?: 'PriceableItemExternalReference', readonly origin: Types.PriceableItemOrigin, readonly foreignId: string }, readonly prices: ReadonlyArray<{ readonly __typename?: 'ItemPrice', readonly id: string, readonly value: number, readonly tariff: { readonly __typename?: 'PriceTariff', readonly id: string, readonly name: string }, readonly revenueDepartment: { readonly __typename?: 'RevenueDepartment', readonly name: string } }> }> } } };


export const InvoicingPriceListV2MetaDocument = gql`
    query invoicingPriceListV2Meta($input: PriceListMetaInput!) {
  priceListV2 {
    priceListMeta(input: $input) {
      id
    }
  }
}
    `;

/**
 * __useInvoicingPriceListV2MetaQuery__
 *
 * To run a query within a React component, call `useInvoicingPriceListV2MetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicingPriceListV2MetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicingPriceListV2MetaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoicingPriceListV2MetaQuery(baseOptions: Apollo.QueryHookOptions<InvoicingPriceListV2MetaQuery, InvoicingPriceListV2MetaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicingPriceListV2MetaQuery, InvoicingPriceListV2MetaQueryVariables>(InvoicingPriceListV2MetaDocument, options);
      }
export function useInvoicingPriceListV2MetaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicingPriceListV2MetaQuery, InvoicingPriceListV2MetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicingPriceListV2MetaQuery, InvoicingPriceListV2MetaQueryVariables>(InvoicingPriceListV2MetaDocument, options);
        }
export type InvoicingPriceListV2MetaQueryHookResult = ReturnType<typeof useInvoicingPriceListV2MetaQuery>;
export type InvoicingPriceListV2MetaLazyQueryHookResult = ReturnType<typeof useInvoicingPriceListV2MetaLazyQuery>;
export type InvoicingPriceListV2MetaQueryResult = Apollo.QueryResult<InvoicingPriceListV2MetaQuery, InvoicingPriceListV2MetaQueryVariables>;
export const InvoicingPriceListV2Document = gql`
    query invoicingPriceListV2($input: PriceListItemsInput!, $options: PriceListItemsOptions) {
  priceListV2 {
    priceListItems(input: $input, options: $options) {
      edges {
        id
        name
        externalReference {
          origin
          foreignId
        }
        prices {
          id
          value
          tariff {
            id
            name
          }
          revenueDepartment {
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useInvoicingPriceListV2Query__
 *
 * To run a query within a React component, call `useInvoicingPriceListV2Query` and pass it any options that fit your needs.
 * When your component renders, `useInvoicingPriceListV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicingPriceListV2Query({
 *   variables: {
 *      input: // value for 'input'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useInvoicingPriceListV2Query(baseOptions: Apollo.QueryHookOptions<InvoicingPriceListV2Query, InvoicingPriceListV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicingPriceListV2Query, InvoicingPriceListV2QueryVariables>(InvoicingPriceListV2Document, options);
      }
export function useInvoicingPriceListV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicingPriceListV2Query, InvoicingPriceListV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicingPriceListV2Query, InvoicingPriceListV2QueryVariables>(InvoicingPriceListV2Document, options);
        }
export type InvoicingPriceListV2QueryHookResult = ReturnType<typeof useInvoicingPriceListV2Query>;
export type InvoicingPriceListV2LazyQueryHookResult = ReturnType<typeof useInvoicingPriceListV2LazyQuery>;
export type InvoicingPriceListV2QueryResult = Apollo.QueryResult<InvoicingPriceListV2Query, InvoicingPriceListV2QueryVariables>;